var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('dialog-form', { ref: "form", attrs: { "dialog-config": _vm.dialogConfig, "form-value": _vm.dialogValue, "form-item-list": _vm.inlineItemList }, on: { "submit": _vm.submitDialogForm } });
};
var staticRenderFns = [];

export { render, staticRenderFns };